import React from 'react';

import {Col, Row} from 'components/Grid';
import SubMenu from './SubMenu';
import MyPicksBar from './MyPicksBar';

const NavBar = ({nav, children}) => (
  <Row>
    <Col size={8}>
      <SubMenu nav={nav}>{children}</SubMenu>
    </Col>
    <Col size={4}>
      <MyPicksBar />
    </Col>
  </Row>
);

export default NavBar;
